import { Button, Col, Layout, Row, Typography } from 'antd';
import React, { Component } from 'react'
import './PublicPage.css';
export class PublicPage extends Component {
    render() {
        return <div style={{ height: '100%' }}>
            <img src="/background.png" className="bg-image" alt="Background" />
            <div style={{ height: "95%" }} className="vertical-center">
                <div style={{ height: '100%', width: '90%', margin: 'auto' }} className="login-card">
                    <Row style={{ height: "100%" }}>
                        <Col xs={0} sm={0} md={14} lg={14} xl={16}>
                            <div
                                style={{
                                    height: "100%",
                                    backgroundImage: `url(/login-bg.jpg)`,
                                    backgroundSize: "cover",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    overflow: "hidden",
                                }}
                            >
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={10} lg={10} xl={8} className="login-background">
                            <Layout style={{ height: '100%', backgroundColor: 'transparent' }}>
                                <Layout.Content style={{ backgroundColor: 'transparent' }}>
                                    <div className="vertical-center" style={{ padding: 30, overflow: 'hidden' }}>
                                        {this.props.children}
                                    </div>
                                </Layout.Content>
                                <Layout.Footer style={{ textAlign: 'center', backgroundColor: 'transparent' }}>
                                    <div>
                                        <Typography.Link href="https://lin.ee/WnkymtA">
                                            <Button>聯繫我們</Button>
                                        </Typography.Link>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '0.6rem', color: 'white' }}>
                                            Copyright © 2023 Omoho+ Provided by Goodhoday
                                        </span>
                                    </div>
                                </Layout.Footer>
                            </Layout>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>;
    }
}

export default PublicPage